<template>
  <div class="view-container">
    <div v-if="code !== 12 && code !== 13" class="view-gabarit">
      <p class="baseline">{{ $t('studyCreation.studyGeneration') }}</p>
      <p class="description">{{ $t('studyGeneration1') }}<br />{{ $t('studyGeneration2') }}</p>
      {{ $t(`studyCode.${code}`) }}
      <div class="progress-bar-container">
        <p><AnimatedValue :value="progress" />%</p>
        <div class="progress-bar">
          <div class="progress-thumb" :style="{ width: `${progress}%` }"></div>
        </div>
      </div>
    </div>
    <div v-else class="view-gabarit">
      <i class="icon-checkstatus"></i>
      <p class="baseline">{{ $t('studyCreation.studyReady') }}</p>
      <button class="study-button main" @click="() => goTo('result')">{{ $t('accessStudy') }}</button>
    </div>
  </div>
</template>

<script>
import AnimatedValue from '@/components/AnimatedValue';

export default {
  components: {
    AnimatedValue,
  },

  data() {
    return {
      progress: 0,
      status: null,
      code: null,
    };
  },

  mounted() {
    this.fetchProcess();
  },

  beforeUnmount() {
    if (this.setTimeout) {
      clearTimeout(this.setTimeout);
    }
    this.$store.dispatch('cancelLoading');
  },

  methods: {
    forceGeocode() {
      const id = this.$route.params.studyId;
      this.$store
        .dispatch('geocode', {
          id,
        })
        .then(() => this.fetchProcess())
        .catch(() => this.fetchProcess());
    },

    fetchProcess() {
      if (this._isBeingDestroyed || this._isDestroyed) {
        if (this.setTimeout) {
          clearTimeout(this.setTimeout);
        }
        return;
      }
      const id = this.$route.params.studyId;
      if (id) {
        this.$store
          .dispatch('fetchProcessStatus', {
            id,
          })
          .then(response => {
            if (this._isBeingDestroyed || this._isDestroyed) {
              if (this.setTimeout) {
                clearTimeout(this.setTimeout);
              }
              return;
            }
            const { code, value, progress } = response;
            this.status = value;
            this.code = code;
            if (code === 10 || code === 11) {
              this.progress = progress;
            }
            if (code === 12 || code === 13) {
              this.progress = 100;
              setTimeout(() => {
                this.$nextTick(() => this.$store.dispatch('cancelLoading'));
              }, 1000);
            } else {
              if (this._isBeingDestroyed || this._isDestroyed) {
                clearTimeout(this.setTimeout);
                return;
              }
              this.setTimeout = setTimeout(() => this.fetchProcess(), 500);

              console.warn(`Study status ${code} - ${this.$t(`studyCode.${code}`)}`);
            }
          });
      }
    },

    goTo(destination) {
      const id = this.$route.params.studyId;
      this.$router.push({ name: destination, params: { studyId: id } });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.view-gabarit {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .icon-checkstatus {
    margin: 15% 0 64px;
    font-size: 160px;
    color: colors.$dark-beige-color;
  }
  .baseline {
    font-size: 26px;
    font-weight: 600;
    display: block;
  }
  .progress-bar-container {
    p {
      font-size: 28px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 0.25em;
    }
  }
  .progress-bar {
    width: 486px;
    height: 16px;
    box-shadow: inset 0 0 3px rgba(#7c7c7c, 0.67);
    border-radius: 10px;
    box-sizing: border-box;
    padding: 3px;
    .progress-thumb {
      box-sizing: border-box;
      width: 0%;
      border-radius: 10px;
      height: 100%;
      overflow: hidden;
      background-color: #1daea1;
      transition: width 1s ease;
    }
  }
}
</style>
